export const websites = {
  SOLE_WEB: 'sole24ore',
  PLUS24: 'plus24',
};